// src/app/u2104Organization/components/form/u2104Role/U2104UseGetOrganizatonRoleHandlers.ts
export interface U3141UseGetChildLotChainHandlersParams<T = unknown> {
  doGetFn: (id: string, childLotChainId: string) => Promise<unknown>;
  onSuccess?: (row: T) => void;
  onError?: (errors: { error: unknown }) => void;
}

// Return type for useU2104UseGetOrganizatonRoleHandlers hook
export interface U3141UseGetChildLotChainHandlersReturn {
  getChildLotChain: (id: string, childLotChainId: string) => void;
}

// Handlers for getting organization role
export function useU3141UseGetChildLotChainHandlers<T extends { id: string } = { id: string }>({
  doGetFn,
  onSuccess,
  onError,
}: U3141UseGetChildLotChainHandlersParams<T>): U3141UseGetChildLotChainHandlersReturn {
  const getChildLotChain = async (id: string, childLotChainId: string) => {
    try {
      const response = (await doGetFn(id, childLotChainId)) as { data: { result: T } };
      const row: T = response.data.result;

      if (onSuccess) {
        onSuccess(row);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { getChildLotChain };
}
